import React from 'react'
import { Batch, Label, Tier } from '~/pages/ProductPage/PresaleTiers'
import type { BatchSection as Settings } from '~/types'
import { cn } from '~/utils/classnames'
import { Section, Title } from './Common'

interface Props {
	section: Settings
}

export const BatchSection: React.FC<Props> = ({ section }) => (
	<Section
		tag={section.tag}
		className="space-y-12 lg:space-y-16"
		style={{
			backgroundColor: section.settings.background_color,
			paddingTop: `${section.settings.size_top}rem`,
			paddingBottom: `${section.settings.size_bottom}rem`,
			color: section.settings.text_color,
			textAlign: section.settings.text_align
		}}
	>
		<Title>{section.settings.title}</Title>
		<div className="max-md:text-18" dangerouslySetInnerHTML={{ __html: section.settings.text }} />
		<ul className="list grid auto-cols-fr grid-flow-row grid-cols-1 gap-5 text-center lg:grid-flow-col">
			{section.blocks.map(({ id, settings }) => (
				<Tier
					key={id}
					className={cn({ 'border-green bg-white': settings.primary })}
					style={{ opacity: settings.opacity }}
				>
					<Label className={cn({ 'bg-green text-white': settings.primary })}>{settings.badge}</Label>
					<Batch dangerouslySetInnerHTML={{ __html: settings.text }} />
				</Tier>
			))}
		</ul>
	</Section>
)
